var map = {
	"./info-sharing-center-de.html": 1015,
	"./info-sharing-center-en.html": 1016,
	"./info-sharing-center-es.html": 1017,
	"./info-sharing-center-fr.html": 1018,
	"./info-sharing-center-ja.html": 1019,
	"./info-sharing-center-pt.html": 1020,
	"./info-sharing-center-zh.html": 1021
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1014;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center ^\.\/info\-sharing\-center\-.*\.html$
// module id = 1014
// module chunks = 0